import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import BtnIcon from '../../../../assets/breadcrumbs/btn_icon.webp';
import './PackageCustomizeTourButton.css';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import PlanYourJourneyModal from '../../../DynamicDestination/PlanYourJourneyModal';

const PackageCustomizeTourButton = ({ packageDetails, isSticky }) => {
  const { country, countrysite, state, slug } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [isJourneyModalOpen, setIsJourneyModalOpen] = useState(false);
  const isDestinationRoute = location.pathname.startsWith('/destination/');
  const buttonText = isDestinationRoute ? 'Plan Your Journey' : 'Enquire Now';

  const handleEnquiryNow = () => {
    if (isDestinationRoute) {
      setIsJourneyModalOpen(true);
      return;
    }

    const countryName =
      packageDetails?.country === 'India' ? packageDetails?.state : packageDetails?.country;
    const packageId = packageDetails?.new_item_code;

    sessionStorage.setItem(
      'tripDetails',
      JSON.stringify({
        countryName: countryName,
        packageId: packageId
      })
    );

    if (!packageId) {
      console.error('Missing packageId');
      return;
    }

    if (slug) {
      navigate(`/destination/${slug}/${packageId}/vacation-spot#month-travelling`, {
        state: {
          packageId: packageId,
          selectedTour: countryName,
          returnTo: `${location.pathname}${location.search}`
        }
      });
      return;
    }

    if (!country || !countrysite || !state) {
      console.error('Missing params:', { country, countrysite, state, packageId });
      return;
    }

    navigate(
      `/explore/${country}/${countrysite}/${state}/${packageId}/vacation-spot#month-travelling`,
      {
        state: {
          packageId: packageId,
          selectedTour: countryName,
          returnTo: `${location.pathname}${location.search}`
        }
      }
    );
  };

  return (
    <>
      <Button
        className={`customize-tour-footer-btn ${isSticky ? 'btn-sticky' : 'btn-none-sticky'}`}
        variant="contained"
        onClick={handleEnquiryNow}>
        <Box className="btn-with-text">
          <Box className="btn-text">{buttonText}</Box>
          <img src={BtnIcon} alt="" />
        </Box>
      </Button>

      {isDestinationRoute && (
        <PlanYourJourneyModal
          open={isJourneyModalOpen}
          onClose={() => setIsJourneyModalOpen(false)}
          tourPackage={packageDetails}
        />
      )}
    </>
  );
};

export default PackageCustomizeTourButton;
